
import api from './api'

export default {

    get(id) {

        return api.get('/clients/' + id, {})
            .then( json => {

                let client = json.data

                return client
            })
    },

    getAddresses(id) {

        return api.get('/clients/' + id + '/addresses', {})
            .then( json => json.data )
    },

    getAll() {

        return api.get('/clients', {})
            .then( json => json.data )
    }
}
